import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/media.ts
const mediaValidationVideoStreamSchema = z.object({
	codec: z.string(),
	width: z.number().int().nonnegative().nullable(),
	height: z.number().int().nonnegative().nullable(),
	averageFrameRate: z.number().nonnegative().nullable()
});
const mediaValidationAudioStreamSchema = z.object({ codec: z.string() });
const mediaContract = oc.prefix("/media").tag("Media").router({
	getMediaInfo: oc.route({
		summary: "Get validation-relevant media metadata",
		method: "GET",
		path: "/{mediaId}/info"
	}).input(z.object({ mediaId: z.string().min(1) })).output(z.object({
		mediaId: z.string(),
		durationSeconds: z.number().nonnegative(),
		sizeBytes: z.string(),
		containers: z.array(z.string()),
		videoStreams: z.array(mediaValidationVideoStreamSchema),
		audioStreams: z.array(mediaValidationAudioStreamSchema)
	})).errors({
		UNAUTHORIZED: {
			status: 401,
			message: "Authentication required"
		},
		MEDIA_NOT_FOUND: {
			status: 404,
			message: "Media not found"
		}
	}),
	getVideoThumbnailId: oc.route({
		summary: "Generate or get thumbnail media id for a video",
		method: "POST",
		path: "/{videoMediaId}/thumbnail-id"
	}).input(z.object({ videoMediaId: z.string().min(1) })).output(z.object({
		videoMediaId: z.string(),
		imageMediaId: z.string()
	})).errors({
		UNAUTHORIZED: {
			status: 401,
			message: "Authentication required"
		},
		MEDIA_NOT_FOUND: {
			status: 404,
			message: "Media not found"
		},
		NOT_VIDEO: {
			status: 400,
			message: "Media is not a video"
		}
	}),
	getAudioUploadUrl: oc.route({
		summary: "Get S3 upload url for audio",
		method: "POST",
		path: "/audio/upload-url"
	}).input(z.object({ isEphemeral: z.boolean().optional() })).output(z.object({
		uploadUrl: z.string(),
		externalId: z.string()
	})).errors({ UNAUTHORIZED: {
		status: 401,
		message: "Authentication required"
	} }),
	getAudioUrl: oc.route({
		summary: "Get file url for an audio media id",
		method: "POST",
		path: "/audio/url"
	}).input(z.object({ audioMediaId: z.string().min(1) })).output(z.object({
		audioMediaId: z.string(),
		fileUrl: z.string()
	})).errors({
		UNAUTHORIZED: {
			status: 401,
			message: "Authentication required"
		},
		MEDIA_NOT_FOUND: {
			status: 404,
			message: "Media not found"
		}
	}),
	registerAudio: oc.route({
		summary: "Register uploaded audio by externalId",
		method: "POST",
		path: "/audio/register"
	}).input(z.object({
		externalId: z.string().min(1),
		metadata: z.record(z.string(), z.unknown()).optional()
	})).output(z.object({
		id: z.string(),
		fileUrl: z.string(),
		duration: z.number(),
		size: z.number(),
		bitrate: z.number(),
		codec: z.string(),
		metadata: z.record(z.string(), z.unknown()).nullable().optional()
	})).errors({ UNAUTHORIZED: {
		status: 401,
		message: "Authentication required"
	} })
});
//#endregion
export { mediaContract };
